import { FC } from "react";

import { useBandContext, useCalendarContext, usePermissionsContext } from "Bands/contexts";
import { EventBlocksType, IEvent, IIconBandSetting } from "Bands/types";
import { Calendar } from "shared/components";
import { IFormOption } from "shared/types";

interface CalendarViewProps {
  eventId?: string;
  setSelectedEventBlocks?: (events: IFormOption[]) => void;
  setSelectedSourceEvent?: (events: IEvent | null) => void;
  blockType?: EventBlocksType;
  infoBlockType?: IIconBandSetting;
}

export const CalendarView: FC<CalendarViewProps> = ({
  eventId,
  setSelectedEventBlocks,
  setSelectedSourceEvent,
  blockType,
  infoBlockType,
}) => {
  const { bandId, birthdays } = useBandContext();
  const { userCanAddEvent } = usePermissionsContext();
  const { today, date, events } = useCalendarContext();

  return (
    <Calendar
      today={today}
      date={date}
      events={events}
      bandCalendar={!!bandId}
      bandId={bandId}
      birthdays={birthdays}
      canAddEvent={!!bandId && userCanAddEvent}
      setSelectedEventBlocks={setSelectedEventBlocks}
      setSelectedSourceEvent={setSelectedSourceEvent}
      eventId={eventId}
      blockType={blockType}
      infoBlockType={infoBlockType}
    />
  );
};
